<!-- <app-catalog-tree [startCategoryId]="categoryId" ></app-catalog-tree> -->
<h1 class="pb-4" i18n="@@catalog-menu" >
   Catalog
</h1>
<app-catalog-main  [startCategoryId]="categoryId"  ></app-catalog-main>